"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNFCertConfig = void 0;
const tslib_1 = require("tslib");
const ArgusUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/ArgusUtils"));
const labels_1 = require("../labels");
const RESOURCES_PACKAGE_VERSION = "1.10.0";
const getNFCertConfig = (user, locale) => ({
    name: "nfcert",
    items: [
        {
            kind: "logo",
            href: "dashboard",
            requiredPermission: null,
            label: (0, labels_1.getLabels)(locale).LOGO_ALT_NFC,
            large: {
                imgSrc: ArgusUtils.toStaticUrl(`resources/versions/${RESOURCES_PACKAGE_VERSION}/images/nfcert-logo.png`),
            },
            mini: {
                imgSrc: ArgusUtils.toStaticUrl(`resources/versions/${RESOURCES_PACKAGE_VERSION}/images/nfcert-logo-light-mini.svg`),
            },
        },
        {
            kind: "user",
            label: user?.name,
            requiredPermission: null,
            imgSrc: ArgusUtils.toApiUrl(`/users/v2/user/${user?.id}/picture`),
            items: [
                {
                    kind: "link",
                    variant: "internal",
                    label: "User settings",
                    requiredPermission: null,
                    href: "user/profile",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: "Logout",
                    requiredPermission: null,
                    href: "authentication/logout",
                },
            ],
        },
        {
            kind: "search",
            label: "search",
            requiredPermission: "showLogsMenu",
        },
        {
            kind: "category",
            label: (0, labels_1.getLabels)(locale).NFCERT_SERVICES,
            requiredPermission: null,
            items: [
                {
                    kind: "link",
                    requiredPermission: null,
                    variant: "external",
                    iconId: "chat",
                    label: (0, labels_1.getLabels)(locale).CHAT,
                    href: "https://chat.nfcert.org/oauth/openid/login",
                },
                {
                    kind: "link",
                    requiredPermission: null,
                    variant: "external",
                    iconId: "nfcWiki",
                    label: (0, labels_1.getLabels)(locale).WIKI,
                    href: "https://wiki.nfcert.org",
                },
            ],
        },
        {
            kind: "category",
            requiredPermission: null,
            label: (0, labels_1.getLabels)(locale).SERVICE_PAGES,
            items: [
                {
                    kind: "link",
                    label: (0, labels_1.getLabels)(locale).DASHBOARD,
                    requiredPermission: null,
                    variant: "internal",
                    iconId: "dashboard",
                    href: "dashboard/redirect",
                },
                {
                    kind: "group",
                    label: (0, labels_1.getLabels)(locale).CASE,
                    iconId: "caseBeta",
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).CASE_CREATE_BETA,
                            requiredPermission: "useCreateCaseSPA",
                            href: "case/create",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).CASE_SEARCH,
                            requiredPermission: "showCasePage",
                            href: "case",
                        },
                    ],
                },
                {
                    kind: "group",
                    label: (0, labels_1.getLabels)(locale).DOCUMENTS,
                    iconId: "document",
                    requiredPermission: "showReportMenu",
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).ROOT_FOLDER,
                            requiredPermission: "viewDocuments",
                            href: "document",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).REPORTS,
                            requiredPermission: null,
                            href: "document/folder/byPath/Reports",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).SERVICE_HANDBOOK,
                            requiredPermission: null,
                            href: "document/folder/byPath/Service%20Handbook",
                        },
                    ],
                },
                {
                    kind: "group",
                    label: (0, labels_1.getLabels)(locale).ASSETS,
                    iconId: "asset",
                    requiredPermission: null,
                    items: [
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).DASHBOARD,
                            requiredPermission: "showAssetPage",
                            href: "dashboard/assetMonitoring",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).ASSETS_SEARCH,
                            requiredPermission: "showAssetPage",
                            href: "asset/assets",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).GROUPS,
                            requiredPermission: "showAssetPage",
                            href: "asset/groups",
                        },
                        {
                            kind: "link",
                            variant: "internal",
                            label: (0, labels_1.getLabels)(locale).OBSERVATIONS,
                            requiredPermission: "showAssetPage",
                            href: "asset/observations",
                        },
                    ],
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).EXT_APPS,
                    iconId: "externalAppBeta",
                    requiredPermission: null,
                    href: "authentication/oauth/clients",
                },
            ],
        },
        {
            kind: "category",
            requiredPermission: null,
            label: (0, labels_1.getLabels)(locale).DATA_INSIGHT,
            items: [
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).EVENT_SEARCH,
                    iconId: "eventSearch",
                    requiredPermission: "showEventPage",
                    href: "event/search/basic",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).SAMPLE_DB,
                    iconId: "sample",
                    requiredPermission: "showSamplePage",
                    href: "sample/search",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).DATASTORE,
                    requiredPermission: "viewDataStoreDescriptors",
                    iconId: "none",
                    href: "datastore",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).PDNS_BETA,
                    iconId: "pdns",
                    requiredPermission: "showPassiveDNSPage",
                    href: "pdns",
                },
                {
                    kind: "link",
                    variant: "internal",
                    label: (0, labels_1.getLabels)(locale).REPUTATION_SEARCH,
                    iconId: "reputationSearch",
                    requiredPermission: "viewObservationData",
                    href: "reputation/observations",
                },
                {
                    kind: "link",
                    variant: "external",
                    label: (0, labels_1.getLabels)(locale).TI,
                    iconId: "threatIntel",
                    requiredPermission: "viewThreatIntelFact",
                    href: "https://misp.app.mnemonic.no",
                },
            ],
        },
    ],
});
exports.getNFCertConfig = getNFCertConfig;
